import(/* webpackMode: "eager" */ "/opt/build/repo/app/training/page.tsx")